import api from "../../index";

export const GetActivityApi = (data) => api.post('user-activity-log',data);